<template>
  <div class="update-labels-popup">
    <div class="header">
      <div class="title ellipsis">{{ $t('popUp.updateResumeLabels.title') }} {{ resumeName }}</div>
    </div>

    <div class="update-labels-container">
      <div class="section">
        <div class="field">
          <div class="title">{{ $t('popUp.updateResumeLabels.labels') }}</div>

          <ResumeLabelsSelect v-model="resumeLabels" :user="user" :is-organization="resumeWorkspace === 1" />
        </div>

        <div class="container center">
          <div class="main-button button-cancel no-margin-top" @click="popupResolve(false)">
            <div class="text">{{ $t('popUp.updateResumeLabels.cancelButton') }}</div>
          </div>

          <div class="main-button button-create no-margin-top" @click="saveLabels">
            <div class="text">{{ $t('popUp.updateResumeLabels.saveButton') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ResumeLabelsSelect from '@/components/ResumeLabelsSelect.vue';

export default {
  name: 'UpdateResumeLabels',

  components: {
    ResumeLabelsSelect,
  },

  data: function () {
    return {
      resumeId: null,
      resumeName: '',
      resumeLabels: [],
      resumeWorkspace: 0,
    };
  },

  computed: {
    ...mapGetters(['popupResolve', 'popupReject', 'popupData', 'user']),
  },

   mounted() {
    const { id, candidate, labels, workspaceType } = this.popupData;

    this.resumeId = id;
    this.resumeName = candidate.firstname;
    this.resumeLabels = labels;
    this.resumeWorkspace = workspaceType;
  },

  methods: {
    async saveLabels() {
      const result = await this.$store.dispatch('resumes.labels.edit', {
        resumeId: this.resumeId,
        labels: this.resumeLabels,
      });

      this.popupResolve(result);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inputs.scss';
@use '@/styles/buttons.scss';
@use '@/styles/responsive/popup.scss';

.update-labels-popup {
  box-sizing: border-box;
  width: 533px;

  .header {
    width: calc(100%);
    border-bottom: 1px solid colors.$light-blue-color;
    padding-bottom: 22px;

    .title {
      color: colors.$light-blue-color;
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .update-labels-container {
    display: flex;

    .section {
      display: flex;
      flex-direction: column;
      width: 100%;

      .container {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        flex-direction: column;

        &.center {
          margin: 0;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
          box-sizing: border-box;

          .button-cancel {
            margin-right: 22px;
          }
        }

        .title-container .title {
          color: #262626;
          font-size: 16px;
        }

        .no-margin-top {
          margin-top: 0;
        }
      }
    }

    .field {
      width: 100%;
      margin: 22px 0 25px 0;

      .title {
        height: 19px;
        color: #939292;
        font-size: 16px;
        margin: 0 0 4px;
      }

      .text-input {
        width: 100%;
      }
    }
  }
}
</style>
